import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";

import { useAuditory, outAuditory } from "@auditory/provider/hooks";
import { logsConfig } from "@auditory/provider/actions";
import { FooterAction } from "@/components/organisms/FooterAction";
import history from "@/utils/history";
import { LIST_TYPE_ROAD } from "../../../../../../constants/list-type-roads";
import { ERROR_MAPPING } from "../../constants/errors-form";
import { StateMachine } from "@/utils/consts";
import { saveUSerData, saveLeadData } from "@/redux/actions/vida";
import helpers from "@/utils/helpers";
import {
  setJobSelected,
  setWorkStatus,
  setCompanyName,
} from "@/redux/actions/jobs";
import { showModalLoading } from "@/redux/actions/global";
import { useLeadsService } from "@/services/leads.service";
import { selectDomicilio } from "@/redux/actions/domcilio";
import { setViewModalError } from "@/redux/actions/global";
import { usePaymentService } from "@/services/payment.service";
import { usePersonService } from "@/services/person.service";
import {
  setBeneficiaryType,
  showModalAddBeneficiaries as showModalAddBeneficiariesAction,
  updateBeneficiaries,
} from "@/redux/actions/beneficiaries";
import { LIST_TYPE_BENEFICIARY } from "@/constants/list-type-beneficiary";

export const SectionAction = ({ nextStep, errors, trigger, data, loading }) => {
  const { dispatch: dispatchAuditory } = useAuditory();
  const dispatch = useDispatch();

  const { userData, leadData } = useSelector((state) => state.vida);
  const { planSelected, addThirdSuccess } = useSelector((state) => state.plans);
  const { state } = useSelector((state) => state.global);
  const { session } = useSelector((state) => state.token);
  const { departamentos, provincias, distritos, validUbigeo } = useSelector(
    (state) => state.domicilio
  );
  const { jobs } = useSelector((state) => state.jobs);
  const { showModalAddBeneficiaries } = useSelector(
    (state) => state.beneficiaries
  );

  const [clickOnNextButton, setClickOnNextButton] = useState(false);
  const [viewFormErrors, setViewFormErrors] = useState(false);

  const ideDepartamento = data?.department?.substring(1);
  const ideProvincia = data?.province?.substring(1);
  const ideDistrito = data?.district?.substring(1);
  const ubigeo = `${ideDepartamento}${ideProvincia}${ideDistrito}`;

  const currentStreetType = LIST_TYPE_ROAD.find(
    (item) => item.value === data?.streetType
  );

  const { sendLeads } = useLeadsService();
  const { getToken } = usePaymentService();
  const { addThirdToQuote } = usePersonService();

  const currentDepartment = departamentos.find(
    (item) => item.value === data?.department
  );
  const currentProvince = provincias.find(
    (item) => item.value === data?.province
  );
  const currentDistrict = distritos.find(
    (item) => item.value === data?.district
  );

  useEffect(() => {
    dispatch(showModalLoading(""));
  }, []);

  const addAddress = () => {
    dispatch(
      selectDomicilio({
        validUbigeo,
        departamento: currentDepartment,
        provincia: currentProvince,
        distrito: currentDistrict,
        nombreVia: data?.address,
        tipoVia: currentStreetType,
        numeroVia: data?.streetNumber,
      })
    );
  };

  const updateConfigLog = () => {
    const typeDocument = String(userData.typeDoc);
    const auditory = outAuditory?.state?.auditoria;
    const configAuditory = {
      tipoDocumento:
        typeDocument.length === 1 ? `0${typeDocument}` : typeDocument,
      numeroDocumento: String(userData.documento),
      correo: data?.email || auditory?.correo,
      telefono: data?.phone || auditory?.telefono,
      producto: "VIDA",
      codigoProducto: auditory?.codigoProducto,
      codigoExterno: userData ? userData?.tercero : auditory?.codigoExterno,
      idLead: leadData ? leadData.idLead : auditory?.idLead,
      canal: "Portal Web",
      origen: auditory?.origen,
      proteccionDatos: auditory?.proteccionDatos,
      comunicacionComercial: auditory?.comunicacionComercial,
      pasoInicialFinalizado: 1,
    };
    logsConfig(dispatchAuditory, configAuditory);
  };

  const getPaymentToken = async () => {
    const payloadToken = {
      producto: "VCT",
      ideCotizacion: planSelected.ideTransaccion,
      correo: data?.email,
      idePlan: String(planSelected.plan.idePlan),
    };
    await getToken(payloadToken);
  };

  const addThird = async () => {
    const user = {
      ...userData,
      correo: data?.email,
      telefono: data?.phone,
    };

    const userAddress = {
      ubigeo,
      nombreVia: data?.address,
      tipoVia: currentStreetType,
      numeroVia: data?.streetNumber || "SN",
    };
    await addThirdToQuote(user, userAddress, planSelected);
  };

  useEffect(() => {
    if (state === StateMachine[4]) {
      return dispatch(setViewModalError(true));
    }
    const functionOfEffect = async () => {
      const splitName = userData.nombres.split(" ");
      const firstName = splitName.map((item) => helpers.capitalizeString(item));
      const userAddress = {
        ubigeo,
        nombreVia: data?.address,
        tipoVia: currentStreetType,
        numeroVia: data?.streetNumber,
      };
      dispatch(
        saveUSerData({
          ...userData,
          names: firstName.join(" "),
          apePaterno: helpers.capitalizeString(userData.apellidoPaterno),
          apeMaterno: helpers.capitalizeString(userData.apellidoMaterno),
          email: data?.email,
          correo: data?.email,
          telefono: data?.phone,
          userAddress,
        })
      );

      dispatch(setBeneficiaryType(data?.beneficiaryType));
      addAddress();

      if (data?.beneficiaryType === "beneficiary-custom") return;

      const leadToSend = {
        ...leadData,
        finalizado: 3,
      };
      await dispatch(saveLeadData(leadToSend));
      await sendLeads(leadToSend);
      await addThird();
      await getPaymentToken();
    };
    if (clickOnNextButton) {
      functionOfEffect();
    }
  }, [state, clickOnNextButton]);

  const sendJobTracking = () => {
    const jobSelected = jobs.find((item) => item.value === Number(data?.job))
      ?.text;
    let keyTracking = `${data?.isWorking} - ${jobSelected}`;

    if (data?.isWorking === "Si") {
      keyTracking = `${keyTracking} - ${data?.company}`;
    }
    helpers.getTagMetadata(
      "Datos Laborales Seguro Vida Devolución Garantizada",
      keyTracking,
      "trackMetadata"
    );
  };

  const sendUbigeoTracking = () => {
    const trackValue = `${helpers.capitalizeString(
      currentDepartment?.text
    )} - ${helpers.capitalizeString(
      currentProvince?.text
    )} - ${helpers.capitalizeString(currentDistrict?.text)}`;
    helpers.getTagMetadata(
      "Dirección Seguro Vida Devolución Garantizada",
      trackValue,
      "trackMetadata"
    );
  };

  useEffect(() => {
    if (state !== StateMachine[4] && clickOnNextButton) {
      dispatch(setJobSelected(data?.job));
      dispatch(setWorkStatus(data?.isWorking));
      dispatch(setCompanyName(data?.company));
      !validUbigeo && sendUbigeoTracking();
      sendJobTracking();

      if (
        session &&
        addThirdSuccess &&
        data?.beneficiaryType === "beneficiary-legal"
      ) {
        dispatch(showModalLoading(""));
        dispatch(updateBeneficiaries([]));
        history.push(nextStep);
      }

      if (data?.beneficiaryType === "beneficiary-custom") {
        helpers.getTagVirtual(
          "sol:comprar:seguro-vida-devolucion-garantizada:loader-elegir-beneficiarios"
        );

        setTimeout(() => {
          dispatch(showModalLoading(""));
          setClickOnNextButton(false);
          dispatch(showModalAddBeneficiariesAction(true));
          helpers.getTagVirtual(
            "sol:comprar:seguro-vida-devolucion-garantizada:elegir-beneficiarios"
          );
        }, 3000);
      }
    }
  }, [
    state,
    addThirdSuccess,
    session,
    clickOnNextButton,
    data?.beneficiaryType,
  ]);

  const onHandleClick = async () => {
    const result = await trigger();

    if (!result) {
      setViewFormErrors(true);
      return;
    }
    setViewFormErrors(false);
    updateConfigLog();

    if (data?.beneficiaryType === "beneficiary-custom") {
      dispatch(
        showModalLoading(
          "Asegúrate de registrar los datos correctos de tus beneficiarios"
        )
      );
    } else {
      dispatch(
        showModalLoading("No olvides tener tu tarjeta de pago a la mano")
      );
      helpers.getTagVirtual(
        "sol:comprar:seguro-vida-devolucion-garantizada:loader-pago"
      );
    }

    const { title } =
      LIST_TYPE_BENEFICIARY.find((_) => _.key === data?.beneficiaryType) || {};
    helpers.getTagMetadata(
      "Agregar beneficiarios Seguro Vida Devolución Garantizada",
      title,
      "trackMetadata"
    );
    setClickOnNextButton(true);
  };

  useEffect(() => {
    if (viewFormErrors && errors) {
      let element;
      for (const [key, value] of Object.entries(ERROR_MAPPING)) {
        if (errors?.[key]) {
          element = document.getElementById(value);
          break;
        }
      }
      element && element.scrollIntoView({ behavior: "smooth" });
      setViewFormErrors(false);
    }
  }, [errors, viewFormErrors]);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter" && !showModalAddBeneficiaries) {
        event.preventDefault();
        onHandleClick();
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [showModalAddBeneficiaries]);

  return (
    <FooterAction
      textButton="Ir a pagar"
      loading={clickOnNextButton || loading}
      onHandleClick={onHandleClick}
    />
  );
};
